import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml', standalone: true })
export class Safe {
  constructor(private sanitizer: DomSanitizer) {}
  // transform(value: any): any {
  //   let strCheck;
  //   if (typeof value === 'string') {
  //     strCheck = value?.replace(/<\/?[^>]+(>|$)|\&nbsp;/g, '');
  //   } else {
  //     value.forEach((data) => {
  //       strCheck = data?.replace(/<\/?[^>]+(>|$)|\&nbsp;/g, '');
  //     });
  //   }
  //   return strCheck;
  // }

  transform(value: any): any {
    const sanitize = (str: string): string =>
      //before sonar
      // str?.replace(/<\/?[^>]+(>|$)|&nbsp;/g, '');

      // After Sonar
      str?.replace(/<\/?[\w\s="/.':;#-\/]+>/gi, '').replace(/&nbsp;/g, '');

    if (Array.isArray(value)) {
      return value.map((item) =>
        typeof item === 'string' ? sanitize(item) : item
      );
    }

    return typeof value === 'string' ? sanitize(value) : value;
  }
}
